/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { breakpoints } from '@coursera/cds-core';

import CourseDescription from 'bundles/video-logged-out-page/components/course-content/CourseDescription';
import CourseInstructors from 'bundles/video-logged-out-page/components/course-content/CourseInstructors';
import CourseReviews from 'bundles/video-logged-out-page/components/course-content/CourseReviews';
import CourseSkills from 'bundles/video-logged-out-page/components/course-content/CourseSkills';
import LessonLectures from 'bundles/video-logged-out-page/components/course-content/LessonLectures';
import TryCourseButton from 'bundles/video-logged-out-page/components/course-content/TryCourseButton';
import type {
  Course,
  Instructor,
  Rating,
  ReviewOverview,
  TopReview,
  VLPItem,
  VLPLesson,
  VLPModule,
} from 'bundles/video-logged-out-page/types/vlpSharedTypes';

const styles = {
  courseContentContainer: css`
    .rc-CourseContentContainer {
      &.is-hidden {
        display: none;
      }

      .vlp-about-course-sub-content {
        ${breakpoints.down('md')} {
          margin-top: 10px;
        }
        ${breakpoints.down('sm')} {
          margin: 0;
          height: auto;
        }

        &.is-hidden {
          height: 0;
          overflow: hidden;
        }
      }
    }
  `,
};

type Props = {
  course: Course;
  courseSlug: string;
  itemId: string;
  currentModule?: VLPModule;
  currentLesson?: VLPLesson;
  skills: Array<string>;
  topReviews?: TopReview[] | null;
  ratings?: Rating | null;
  instructors: Array<Instructor>;
  reviewOverview?: ReviewOverview;
  lectureItems: Array<VLPItem>;
  hideLessonLectures?: boolean;
};

const CourseContentContainer = ({
  course,
  courseSlug,
  itemId,
  currentModule,
  currentLesson,
  lectureItems,
  instructors,
  ratings,
  skills,
  reviewOverview,
  topReviews,
  hideLessonLectures,
}: Props) => {
  const lectureItemsForCurrentLesson = lectureItems.filter((item) => item.lessonId === currentLesson?.id);
  return (
    <section className="rc-CourseContentContainer" css={styles.courseContentContainer}>
      <div className="vlp-about-course-sub-content">
        <CourseDescription courseSlug={course.slug} courseDescription={course.description} />
        <CourseSkills skills={skills} />
        <CourseReviews ratings={ratings} topReviews={topReviews} reviewOverview={reviewOverview} />

        {!hideLessonLectures && currentModule && currentLesson && (
          <LessonLectures
            courseSlug={courseSlug}
            itemId={itemId}
            currentModule={currentModule}
            lessonLectureItems={lectureItemsForCurrentLesson}
          />
        )}

        <CourseInstructors instructors={instructors} />

        <TryCourseButton
          buttonCss={{
            '&&': {
              fontWeight: 'normal',
            },
          }}
          productLink={`/learn/${course.slug}`}
          buttonClass="try-course"
          sectionName="bottom_banner"
          buttonName="signup"
        />
      </div>
    </section>
  );
};

export default CourseContentContainer;
